module.exports = __webpack_public_path__ + "static/you-travel-2375140363e42e5b129b94363fb266cb.jpg";